import { removeSparkolCookies } from 'js/shared/helpers/tokenHelpers';
import isElectron from 'js/shared/helpers/isElectron';
import { getHistory } from 'js/store/history';
import { ROUTE_CODES } from 'js/config/routes';

import { cognitoSignOut } from './authHelper';

export async function logOutAndReload() {
  removeSparkolCookies();
  await cognitoSignOut();
  if (isElectron()) {
    const history = getHistory();
    history.push(ROUTE_CODES.DESKTOP_LOGIN);
  } else {
    window.location.reload();
  }
}
